export function buildRouteUrl(path, query) {
  var routePath = path || '/';
  var queryObj = query || {};
  var params = [];
  var origin = window.location.origin || (window.location.protocol + '//' + window.location.host);

  Object.keys(queryObj).forEach(function(key) {
    var value = queryObj[key];

    if (Array.isArray(value)) {
      value.forEach(function(item) {
        if (item !== undefined && item !== null && item !== '') {
          params.push(encodeURIComponent(key) + '=' + encodeURIComponent(item));
        }
      });
    } else if (value !== undefined && value !== null && value !== '') {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    }
  });

  var queryString = params.join('&');
  return origin + routePath + (queryString ? '?' + queryString : '');
}

export function getCurrentRouteUrl(route) {
  return buildRouteUrl(route.path || '/', route.query || {});
}

export function getOldHashRedirectUrl() {
  var hash = window.location.hash;

  if (!hash || hash.indexOf('#/') !== 0) {
    return '';
  }

  var origin = window.location.origin || (window.location.protocol + '//' + window.location.host);
  return origin + hash.slice(1);
}



// WEBPACK FOOTER //
// ./src/utils/share-url.js